import React, { useEffect } from 'react';
import { Tag } from '../../../../../common/tags/tagTypes';
import { fetchTagsFromDb } from '../../../tags/tagsService';
import { toArray } from 'lodash';
import TagElementPillsContainer from '../../../tags/TagElementPillsContainer';
import { TaskTagData } from '../taskPillsTypes';

import './TaskTagPills.scss';

const TaskTagPills: React.FC<TaskTagData> = ({ tagIds }) => {
    const [elementTags, setElementTags] = React.useState<Tag[]>([]);
    const tagsCount = elementTags.length;

    // Temporary method of fetching tag data, to be replaced with redux later (WEB-15003)
    useEffect(() => {
        if (!tagIds || tagIds.length === 0) {
            setElementTags([]);
            return;
        }

        fetchTagsFromDb({ tagIds: toArray(tagIds) }).then((tags) => {
            setElementTags(tags);
        });
    }, [tagIds]);

    if (!tagsCount) return null;

    return (
        <div className="TaskTagPills">
            <TagElementPillsContainer tags={elementTags} size="xs" />
        </div>
    );
};

export default TaskTagPills;
